/**
 * Icon3D — premium 3D-pillow wrapper around a Lucide icon
 * Variants follow the brand palette with soft volumetric depth (gradient + highlight + shadow).
 */
const variants = {
  deepBlue: {
    bg: "linear-gradient(160deg, #8a87e6 0%, #4f4cc9 45%, #2a2895 100%)",
    shadow: "0 14px 30px rgba(53,50,179,0.38), inset 0 -4px 10px rgba(0,0,0,0.22), inset 0 2px 4px rgba(255,255,255,0.45)",
  },
  vividBlue: {
    bg: "linear-gradient(160deg, #8fc1ff 0%, #3787F5 45%, #1d5fc4 100%)",
    shadow: "0 14px 30px rgba(55,135,245,0.38), inset 0 -4px 10px rgba(0,0,0,0.18), inset 0 2px 4px rgba(255,255,255,0.50)",
  },
  aqua: {
    bg: "linear-gradient(160deg, #7df0d6 0%, #12DDB5 45%, #0aa388 100%)",
    shadow: "0 14px 30px rgba(18,221,181,0.40), inset 0 -4px 10px rgba(0,0,0,0.15), inset 0 2px 4px rgba(255,255,255,0.55)",
  },
  white: {
    bg: "linear-gradient(160deg, #ffffff 0%, #ecefff 60%, #c9cdf6 100%)",
    shadow: "0 14px 30px rgba(53,50,179,0.18), inset 0 -3px 8px rgba(53,50,179,0.10), inset 0 2px 4px rgba(255,255,255,0.9)",
  },
};

const sizeMap = {
  sm: { box: "w-11 h-11", icon: 20 },
  md: { box: "w-14 h-14", icon: 26 },
  lg: { box: "w-16 h-16", icon: 30 },
  xl: { box: "w-20 h-20", icon: 36 },
};

export const Icon3D = ({
  icon: Icon,
  variant = "deepBlue",
  size = "md",
  iconColor,
  className = "",
}) => {
  const v = variants[variant] || variants.deepBlue;
  const s = sizeMap[size] || sizeMap.md;
  const fg =
    iconColor || (variant === "white" ? "#3532B3" : "#FFFFFF");

  return (
    <div
      className={`relative ${s.box} rounded-[30%] flex items-center justify-center transition-transform duration-300 ${className}`}
      style={{ background: v.bg, boxShadow: v.shadow }}
    >
      {/* Glossy highlight */}
      <span
        aria-hidden
        className="absolute top-[10%] left-[14%] w-[42%] h-[26%] rounded-full bg-white/40 blur-[3px] pointer-events-none"
      />
      {/* Bottom soft glow */}
      <span
        aria-hidden
        className="absolute bottom-[8%] right-[14%] w-[38%] h-[22%] rounded-full bg-black/10 blur-[6px] pointer-events-none"
      />
      <Icon
        size={s.icon}
        strokeWidth={2}
        style={{ color: fg, filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.22))" }}
        className="relative z-10"
      />
    </div>
  );
};
